import { FC, useContext, useState, useEffect, useRef } from 'react';

import { NumberInput } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ICalculatorCashProps } from './interfaces';
import s from './СalculatorCash.module.scss';

export const CalculatorCash: FC<ICalculatorCashProps> = ({
  totalCash,
  bordered = true,
}) => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency },
    },
  } = useContext(SettingsContext);
  const [sum, setSum] = useState<number | ''>(totalCash);
  const [change, setChange] = useState<number>(0);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef?.current) {
      inputRef?.current?.focus();
      inputRef?.current?.select();
    }
  }, []);

  useEffect(() => {
    if (sum === '' || typeof sum !== 'number') {
      setChange(0);
      return;
    }

    const calculatedChange = Number((sum - totalCash).toFixed(2));
    setChange(calculatedChange > 0 ? calculatedChange : 0);
  }, [sum, totalCash]);

  const handleSumChange = (value: number | ''): void => {
    setSum(value);
  };

  return (
    <div className={s.container}>
      <NumberInput
        ref={inputRef}
        value={sum}
        onChange={handleSumChange}
        rightContent={currency.sign}
        title={t('sum')}
        bordered={bordered}
      />
      <NumberInput
        iconName="CashierIcon"
        value={change}
        onChange={() => {
          ('');
        }}
        disabled={true}
        rightContent={currency.sign}
        title={t('calculator.change')}
        bordered={bordered}
        className={s.input}
      />
    </div>
  );
};
